import { makeStyles } from '@material-ui/core';
import { ThemeModes } from 'UI/theme/themeMode';

const textColors = {
  opaque: theme => theme.palette.text.disabled,
  normal: theme => theme.palette.text.primary
};

export const useStyles = makeStyles(theme => ({
  editorContainer: {
    width: '100%',
    margin: theme.spacing(1.5, 0),
    color: ({ color }) =>
      (textColors[color] && textColors[color](theme)) || theme.palette.text.primary,
    ...(theme.palette.type === ThemeModes.Dark && {
      '& .tox-tinymce': {
        borderColor: theme.palette.divider
      },
      '& .tox .tox-edit-area__iframe': {
        backgroundColor: 'transparent'
      },
      '& .tox .tox-toolbar-overlord, & .tox .tox-toolbar, & .tox .tox-toolbar__primary, & .tox .tox-statusbar':
        {
          backgroundColor: theme.palette.grey[300]
        }
    })
  },
  errorText: {
    margin: theme.spacing(0, 0, 1)
  }
}));
